import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { passwordRecovery } from '../../redux/reducers/auth';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import PasswordRecoveryForm from './components/PasswordRecoveryForm';
// styles
import styles from './PasswordRecovery.mod.css';

class PasswordRecovery extends Component {
  render() {
    const { passwordRecovery } = this.props;

    return (
      <PageWrapper className={styles.container}>
        <PasswordRecoveryForm onSubmit={passwordRecovery} />
      </PageWrapper>
    );
  }
}

export default connect(
  null,
  { passwordRecovery }
)(PasswordRecovery);



// WEBPACK FOOTER //
// ./src/containers/PasswordRecovery/PasswordRecovery.jsx